import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind utilities win over earlier ones.
 *
 * Every component in `src/ui` takes a `className`, and a caller must be able to
 * override a variant's own utility (`px-3` → `px-6`) without fighting source
 * order. `clsx` handles conditionals; `twMerge` resolves the conflicts.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
